import React from 'react';

const SafetyLifecycle = () => {
  const expertise = [
    {
      title: "SIF Design",
      description: "From cause/effect to implementation",
      icon: "fas fa-drafting-compass",
      details: "Complete safety instrumented function design ensuring all hazards are properly addressed"
    },
    {
      title: "SIL Assessment",
      description: "Calculations and verification",
      icon: "fas fa-calculator",
      details: "Rigorous Safety Integrity Level determination using proven methodologies"
    },
    {
      title: "LOPA",
      description: "Layer of Protection Analysis",
      icon: "fas fa-layer-group",
      details: "Comprehensive analysis of protection layers to ensure adequate risk reduction"
    },
    {
      title: "Lifecycle Management",
      description: "Digital tools (SLM, etc.)",
      icon: "fas fa-sync-alt",
      details: "Modern digital solutions for managing safety systems throughout their operational life"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Safety Lifecycle Expertise</h2>
          <p className="text-xl text-gray-300">End-to-end functional safety management</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expertise.map((item, index) => (
            <div key={index} className="bg-gray-800 p-8 rounded-lg hover:bg-gray-700 transition-colors group">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <i className={`${item.icon} text-3xl text-blue-400 group-hover:text-blue-300 transition-colors`}></i>
                </div>
                <div className="flex-grow">
                  <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
                  <p className="text-blue-400 mb-3">{item.description}</p>
                  <p className="text-gray-300">{item.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 relative">
          <img
            src="/assets/asset-17.jpg"
            alt="Process flow diagram"
            className="w-full rounded-lg shadow-2xl opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default SafetyLifecycle;
